import React from 'react';
import { connect } from 'react-redux';
import GLOBAL_STYLES from '../styles';
import { Button, Form } from 'react-bootstrap';
import {
  getHoursMinutes,
  convertTimestampDate,
  convertTimestampMD,
  getWeightUom,
} from '../helpers/misc';
import cloneDeep from 'lodash.clonedeep';
import { app } from '../state/actions';


const mapStateToProps = state => ({
  colorScheme: state.main.colorScheme,
  authorizedModules: state.main.authorizedModules,
  openMachine: state.app.openMachine,
});

const mapDispatchToProps = dispatch => ({
  updateNotesInitValue: payload => dispatch(app.updateNotesInitValue(payload)),
  updateNotesModalCb: payload => dispatch(app.updateNotesModalCb(payload)),
});

const ScheduledJob = props => {
  const {
    scheduleObj,
    jobs,
    colorScheme,
    isLast,
    removeJob,
    updateNotesInitValue,
    updateNotesModalCb,
    updateNote,
    updateShifts,
    authorizedModules,
    openMachine,
    updatePriority,
    updateEngineerStartup,
  } = props;
  
  const jobArr = jobs.find(jobArr => jobArr.some(jobObj => scheduleObj.jobNumbers.includes(jobObj.jobNumber)));
  const weightUom = getWeightUom(jobs?.[0]?.[0]?.jobLocator);
  const totalMaterials = jobArr?.length ? [...jobArr.reduce((totals, job) => {
    if(!job.partMaterials) return totals;
    job.partMaterials.forEach(material => {
      let matTotal = totals.get(material.materialNumber) ?? 0;
      matTotal += material.requiredQuantity;
      totals.set(material.materialNumber, matTotal);
    });
    return totals;
  }, new Map()).entries()] : [];
  const totalContainers = jobArr?.length ? jobArr.reduce((total, job) => total + (!job.containerQuantity ? 0 : Math.ceil(job.startQty / job.containerQuantity)), 0) : 0;
  
  const handleDeleteJobClick = () => {
    if(window.confirm('Are you sure you want to remove this job from the schedule?'))
      removeJob(cloneDeep(jobArr));
  };
  
  let shiftNames = [];
  if(openMachine.machineCategory === 'ASSEMBLY') {
    if(scheduleObj.shifts) shiftNames = scheduleObj.shifts;
    else {
      shiftNames = openMachine?.standards?.shiftTimes ? [...openMachine.standards.shiftTimes.reduce((set, cur) => {
        set.add(cur.shiftName);
        return set;
      }, new Set()).values()].sort() : [];
      shiftNames = shiftNames.map(name => {
        const curShiftObj = scheduleObj.shifts ? scheduleObj.shifts.find(o => o.name = name) : null;
        if(!curShiftObj) return {
          name,
          enabled: true,
        };
        return {
          name,
          enabled: curShiftObj.enabled,
        };
      });
    }
  }
  
  return (
    <div
      style={{
        ...styles.container,
        borderColor: GLOBAL_STYLES[colorScheme].fgColor,
        marginBottom: isLast ? 20 : 0,
        backgroundColor: jobArr[0].unit === 'RD' ?
          GLOBAL_STYLES.CONSTANTS.yellowColor :
          GLOBAL_STYLES.CONSTANTS.greenColor,
      }}
    >
      <div style={styles.textContainer}>
        <p style={styles.text}>
        <span style={styles.title}>
          {`JOB${scheduleObj.jobNumbers.length > 1 ? 'S' : ''}: `}
        </span>
          {scheduleObj.jobNumbers.join(' & ')}
        </p>
        <p style={styles.text}>
        <span style={styles.title}>
          {`TOOL: `}
        </span>
          {jobArr ? `${jobArr[0].toolNumber}${jobArr[0].toolLocation ? ` (${jobArr[0].toolLocation})` : ''}` : null}
        </p>
        {jobArr && jobArr[0].lastPmDate ?
          <p style={styles.text}>
          <span style={styles.title}>
            {`LAST PM: `}
          </span>
            {convertTimestampDate(jobArr[0].lastPmDate)}
          </p> :
          null
        }
        {jobArr && jobArr[0].pmCycle ?
          <p style={styles.text}>
          <span style={styles.title}>
            {`PM CYCLE: `}
          </span>
            {`${(((jobArr[0].cycleCount ? jobArr[0].cycleCount : 0) / jobArr[0].pmCycle) * 100).toFixed(0)}%`}
          </p> :
          null
        }
        <p style={styles.text}>
        <span style={styles.title}>
          {`PART${scheduleObj.jobNumbers.length > 1 ? 'S' : ''}: `}
        </span>
          {jobArr ? jobArr.map(j => j.partNumber).join(' & ') : null}
        </p>
        <p style={styles.text}>
        <span style={styles.title}>
          {`QTY: `}
        </span>
          {jobArr ? jobArr[0].startQty : null}
        </p>
        <p style={styles.text}>
        <span style={styles.title}>
          {`MATERIALS: `}
        </span>
          {totalMaterials?.length ? totalMaterials.map(([materialNumber, total]) => `${materialNumber} (${Math.round(total)} ${weightUom})`).join(', ') : null}
        </p>
        <p style={styles.text}>
        <span style={styles.title}>
          {`CONTAINERS: `}
        </span>
          {jobArr?.[0]?.containerPartNumber ? `${jobArr?.[0]?.containerPartNumber} (${totalContainers})` : null}
        </p>
        <p style={styles.text}>
        <span style={styles.title}>
          {`RUNTIME: `}
        </span>
          {jobArr ? getHoursMinutes(jobArr[0].stdRunTime) : null}
        </p>
        {openMachine.machineCategory === 'ASSEMBLY' ?
          <div style={styles.shiftRow}>
            <p style={styles.text}>
            <span style={styles.title}>
              {`SHIFTS: `}
            </span>
            </p>
            {shiftNames.map(({ name, enabled }, index, arr) => (
              <Form.Check
                key={name}
                style={styles.shiftCheck}
                type="checkbox"
                label={name}
                disabled={authorizedModules.includes('READ_ONLY') || (enabled && arr.filter(o => o.enabled).length === 1)}
                checked={enabled}
                onChange={e => {
                  const newShiftNames = cloneDeep(shiftNames);
                  newShiftNames[index].enabled = e.target.checked;
                  updateShifts(newShiftNames);
                }}
              />
            ))}
          </div> :
          null
        }
        <p style={styles.text}>
        <span style={styles.title}>
          {`REQUIRED COMPLETION: `}
        </span>
          {jobArr ? convertTimestampDate(jobArr[0].scheduledCompletionDate) : null}
        </p>
        <p style={styles.text}>
        <span style={styles.title}>
          {`START: `}
        </span>
          {convertTimestampMD(scheduleObj.startTime)}
        </p>
        <p style={styles.text}>
        <span style={styles.title}>
          {`END: `}
        </span>
          {convertTimestampMD(scheduleObj.endTime)}
        </p>
        <div style={styles.shiftRow}>
          <p style={styles.text}>
            <span style={styles.title}>
              {`PRIORITY: `}
            </span>
          </p>
          <Form.Check
            style={styles.shiftCheck}
            type="checkbox"
            label=""
            disabled={authorizedModules.includes('READ_ONLY')}
            checked={scheduleObj.isPriority === true}
            onChange={e => updatePriority(e.target.checked)}
          />
        </div>
        <div style={styles.shiftRow}>
          <p style={styles.text}>
            <span style={styles.title}>
              {`ENGINEER STARTUP: `}
            </span>
          </p>
          <Form.Check
            style={styles.shiftCheck}
            type="checkbox"
            label=""
            disabled={authorizedModules.includes('READ_ONLY')}
            checked={scheduleObj.isEngineerStartup === true}
            onChange={e => updateEngineerStartup(e.target.checked)}
          />
        </div>
        <p style={styles.text}>
        <span style={styles.title}>
          {`NOTES: `}
        </span>
          {scheduleObj.notes ? scheduleObj.notes : ''}
          {
            !authorizedModules.includes('READ_ONLY') ?
              <Button
                size="sm"
                variant="primary"
                onClick={() => {
                  updateNotesInitValue(scheduleObj.notes);
                  updateNotesModalCb(note => updateNote(note));
                }}
                style={styles.noteButton}
              >
                EDIT
              </Button> :
              null
          }
        </p>
      </div>
      {
        !authorizedModules.includes('READ_ONLY') ?
          <div style={styles.buttonContainer}>
            <i
              className={`fa fa-trash fa-2x toolbar-button`}
              style={styles.trashButton}
              onClick={handleDeleteJobClick}
            />
          </div> :
          null
      }
    </div>
  );
};

const styles = {
  container: {
    userSelect: 'none',
    padding: 5,
    paddingLeft: 10,
    paddingRight: 5,
    margin: 0,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 1,
    borderStyle: 'dashed',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  textContainer: {
    flex: 1,
    paddingRight: 10,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontWeight: 'bold',
  },
  text: {
    margin: 0,
    padding: 0,
  },
  noteButton: {
    marginLeft: 7,
  },
  trashButton: {
    cursor: 'pointer',
  },
  shiftRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  shiftCheck: {
    marginLeft: 15,
  },
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledJob);